export default class TemplateAccount {
  constructor(template) {
    this.$el = $(template.el);
    $('.delete-address', this.$el).on('click', event => this.deleteAddress(event));
    $('.edit-address', this.$el).on('click', event => this.editAddress(event));
    $('.add-new-address', this.$el).on('click', () => this.addNewAddress());
    $('.toggle-forgetfulness', this.$el).on('click', () => this.recoverPassword());
    $('.address-country', this.$el).on('change', () => this.updateProvinceSelectText());


    if (this.$el.hasClass('template-customers-addresses')) { this.prepareAddresses(); }
    if (this.$el.hasClass('template-customers-login')) { this.checkForReset(); }
    if (window.location.hash === '#recover') { return this.recoverPassword(); }
  }

  recoverPassword() {
    $('.recover-password', this.$el).toggle();
    $('.customer-login', this.$el).toggle();
  }

  checkForReset() {
    if ($('.reset-check', this.$el).data('successful-reset') === true) {
      $('.successful-reset', this.$el).show();
    }
  }

  prepareAddresses() {
    new Shopify.CountryProvinceSelector('address-country', 'address-province', {
      hideElement: 'address-province-container',
    });

    const addresses = $('.customer-address', this.$el);

    if (addresses.length) {
      return addresses.map((index, address) => {
        const addressID = $(address).data('address-id');

        return new Shopify.CountryProvinceSelector(`address-country-${addressID}`, `address-province-${addressID}`, {
          hideElement: `address-province-container-${addressID}`,
        });
      });
    }
  }

  deleteAddress(e) {
    const addressID = $(e.target).parents('[data-address-id]').data('address-id');
    return Shopify.CustomerAddress.destroy(addressID);
  }

  editAddress(e) {
    const addressID = $(e.target).parents('[data-address-id]').data('address-id');
    $('.customer-address', this.$el).removeClass('editing').find('.edit-address').removeClass('disabled');
    $(`.customer-address[data-address-id='${addressID}']`, this.$el).addClass('editing').find('.edit-address').addClass('disabled');
    $('.customer-address-edit-form, .customer-new-address', this.$el).addClass('hidden');

    return $(`.customer-address-edit-form[data-address-id='${addressID}']`, this.$el).removeClass('hidden');
  }

  addNewAddress() {
    $('.customer-address', this.$el).removeClass('editing').find('.edit-address').removeClass('disabled');
    $('.customer-address-edit-form', this.$el).addClass('hidden');
    return $('.customer-new-address', this.$el).removeClass('hidden');
  }

  updateProvinceSelectText() {
    return $('.address-province', this.$el).siblings('.selected-text').text(`-- ${Theme.pleaseSelectText} --`);
  }
}
